import { ParsedURL } from 'shared/utils/urls';
/**
 * Fire click tracking by opening new window with the given Url
 * In Proof, it sends a message instead
 */
export var fireClickTracking = function (url) {
    // Do not open new window in proof view, but broadcast clickTag URL instead
    var isInProof = !!new ParsedURL().queryParam('proof');
    if (isInProof && window.iframeAdToProof) {
        window.iframeAdToProof.broadcast({
            type: 'clickTag',
            msg: url,
        });
        return;
    }
    window.open(url, '_blank');
};
